var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.label)?_c('label',{staticClass:"form-label aisea-text-14-400-gray",class:{ required: _vm.isRequired }},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }